import styled from 'styled-components'

export default styled.div`
float: right!important;
font-family: 'VT323', monospace !important;
`
